// core
import React from "react";
import styles from "./ProductSettingsClientWrapper.module.scss";
import ValidationMessage from "../../../../common/components/Forms/ValidationMessage/ValidationMessage";
import cx from "classnames";

type SettingsWrapperProps = {
    className?: string;
    error?: string;
};

const ProductSettingsClientWrapper: React.FC<SettingsWrapperProps> = (props) => {
    const { className, error, children } = props;

    return (
        <React.Fragment>
            <div
                className={cx(styles["wrapper"], {
                    [className]: !!className
                })}>
                {children}
            </div>

            {error && <ValidationMessage isCentered>{error}</ValidationMessage>}
        </React.Fragment>
    );
};

export default ProductSettingsClientWrapper;
